module.exports = __webpack_public_path__ + "static/media/pickupmap-dean-martin.c516a62d.jpg";